import { Reducer } from "redux";
import {
  IDataTranscriberValidationQueueState,
  DataTranscriberValidationQueueActionTypes,
} from "../types";

// Type-safe initialState!
const initialState: IDataTranscriberValidationQueueState = {
  workflowItemSteps: [],
  openWorkflowItemStep: null,
  id: "",
  loadingWorkflowSteps: false,
  totalWorkflowItemSteps: 0,
};

const reducer: Reducer<IDataTranscriberValidationQueueState> = (state = initialState, action) => {
  //console.log('action', action);
  switch (action.type) {
    case DataTranscriberValidationQueueActionTypes.LOADING_WORKFLOW_STEPS: {
      return { ...state, loadingWorkflowSteps: action.value };
    }
    case DataTranscriberValidationQueueActionTypes.TOTAL_WORKFLOW_STEPS: {
      return { ...state, totalWorkflowItemSteps: action.value };
    }
    case DataTranscriberValidationQueueActionTypes.SEARCH_REPORTS: {
      let _state = { ...state };
      _state = { ...state, workflowItemSteps: action.value };
      return _state;
    }
    case DataTranscriberValidationQueueActionTypes.GET_REPORT_DATA: {
      let _state = { ...state };
      _state = { ...state, workflowItemSteps: action.value };
      return _state;
    }
    case DataTranscriberValidationQueueActionTypes.OPEN_REPORT: {
      let _state = { ...state };
      _state = { ...state, openWorkflowItemStep: action.value };
      return _state;
    }
    case DataTranscriberValidationQueueActionTypes.ASSIGN_AND_OPEN_REPORT: {
      let _state = { ...state };
      _state = { ...state, openWorkflowItemStep: action.value };
      return _state;
    }
    case DataTranscriberValidationQueueActionTypes.UNASSIGN: {
      let _state = { ...state };
      _state.workflowItemSteps = [
        ..._state.workflowItemSteps.map((item) =>
          item.id == action.value.id ? { ...item, ...action.value } : item
        ),
      ];
      return _state;
    }
    case DataTranscriberValidationQueueActionTypes.SAVE_DATA_TRANSCRIBE_VALIDATION: {
      let _state = { ...state };
      _state.workflowItemSteps = [
        ..._state.workflowItemSteps.map((item) =>
          item.id == action.value.id ? { ...item, ...action.value } : item
        ),
      ];
      _state.openWorkflowItemStep = action.value;
      return _state;
    }
    case DataTranscriberValidationQueueActionTypes.COMPLETE_DATA_ENTRY: {
      let _state = { ...state };
      _state = { ...state, openWorkflowItemStep: action.value };
      return _state;
    }
    default: {
      return state;
    }
  }
};

export default reducer;
